import { Splide } from "@splidejs/splide";

class RelatedTrainingsBlog {
  root;

  constructor(root) {
    this.root = root;
  }

  init = (lazy = null) => {
    const sliderContainer = this.root.querySelector(
      ".related-trainings-slider"
    );

    if (!sliderContainer) return;

    const elements = [...sliderContainer.querySelectorAll(".splide__slide")]
      .length;

    const splide = new Splide(sliderContainer, {
      perPage: 3,
      perMove: 1,
      pagination: false,
      gap: "32px",
      arrows: elements > 3,
      type: "slide",
      breakpoints: {
        992: {
          perPage: 2,
          arrows: elements > 2,
        },
        780: {
          gap: "20px",
        },
        550: {
          perPage: 1,
          arrows: elements > 1,
        },
      },
    }).mount();

    splide.on("mounted", function () {
      //   lazy.update();
    });
  };
}

export default RelatedTrainingsBlog;
